import React from 'react';
import PropTypes from 'prop-types';
import { Search } from '@telus-uds/components-web';

const TextSearchFilter = ({ filterString, setFilterString, placeholder }) => (
  <Search
    placeholder={placeholder}
    value={filterString || ''}
    onChange={setFilterString}
    onClear={() => setFilterString('')}
    onSubmit={() => {}}
  />
);

TextSearchFilter.propTypes = {
  filterString: PropTypes.string,
  setFilterString: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired
};

TextSearchFilter.defaultProps = {
  filterString: ''
};

export default TextSearchFilter;
